/**
 * @file React state synced to print-format localStorage preference.
 */

import { useCallback, useEffect, useState } from 'react';
import {
  PRINT_FORMAT_4X6,
  PRINT_FORMAT_RECEIPT,
  PRINT_FORMAT_STORAGE_KEY,
  getStoredPrintFormat,
  setStoredPrintFormat,
} from '../utils/printFormatPreference';

export function usePrintFormatPreference() {
  const [format, setFormat] = useState(getStoredPrintFormat);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === null || e.key === PRINT_FORMAT_STORAGE_KEY) {
        setFormat(getStoredPrintFormat());
      }
    };
    const onCustom = (e) => {
      if (e.detail?.format) {
        setFormat(e.detail.format);
      } else {
        setFormat(getStoredPrintFormat());
      }
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('print-format-changed', onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('print-format-changed', onCustom);
    };
  }, []);

  const setPrintFormat = useCallback((next) => {
    setFormat(setStoredPrintFormat(next));
  }, []);

  const togglePrintFormat = useCallback(() => {
    setPrintFormat(format === PRINT_FORMAT_4X6 ? PRINT_FORMAT_RECEIPT : PRINT_FORMAT_4X6);
  }, [format, setPrintFormat]);

  const isReceipt = format === PRINT_FORMAT_RECEIPT;

  return {
    format,
    isReceipt,
    is4x6: format === PRINT_FORMAT_4X6,
    setPrintFormat,
    togglePrintFormat,
  };
}
